<template>
  <div class="product-photo-carousel">
    <swiper
      v-if="urls.length > 1"
      :modules="modules"
      :auto-height="autoHeight"
      pagination
      navigation
      :data-testid="`${testIdPrefix}-carousel`"
    >
      <swiper-slide v-for="(url, index) in urls" :key="index">
        <img
          :src="url"
          :alt="alt"
          :class="photoClass"
          :data-testid="`${testIdPrefix}-photo`"
          @click="$emit('photo-click')"
        />
      </swiper-slide>
    </swiper>
    <img
      v-else
      :src="urls[0]"
      :alt="alt"
      :class="photoClass"
      :data-testid="`${testIdPrefix}-photo`"
      @click="$emit('photo-click')"
    />
  </div>
</template>

<script>
import { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default {
  name: 'ProductPhotoCarousel',

  components: { Swiper, SwiperSlide },

  props: {
    urls: { type: Array, required: true },
    alt: { type: String, default: '' },
    photoClass: { type: String, default: '' },
    autoHeight: { type: Boolean, default: false },
    testIdPrefix: { type: String, required: true }
  },

  emits: ['photo-click'],

  setup() {
    return { modules: [Pagination, Navigation] }
  }
}
</script>

<style scoped>
.product-photo-carousel {
  --swiper-theme-color: hsl(var(--main-brand-hue), var(--main-brand-saturation-600), var(--main-brand-lightness-600));
  --swiper-navigation-size: 32px;
  --swiper-pagination-bullet-inactive-color: #fff;
  --swiper-pagination-bullet-inactive-opacity: 0.8;
}

.product-photo-carousel :deep(.swiper-pagination-bullet) {
  box-shadow: 0 0 0 1px rgb(0 0 0 / 0.25);
}
</style>
